import { createContext, useContext, type ReactNode } from 'react';

// Permissions sind im Standalone-PM-Frontend deaktiviert. Solange pm-api
// keinen echten Login verlangt, hat dieser Provider einen statischen
// Super-Admin-State. PermissionRoute / RequirePermission greifen alle.

interface PermissionContextType {
  permissions: string[];
  role: string;
  isSuperAdmin: boolean;
  isLoading: boolean;
  hasPermission: (permission: string) => boolean;
  hasAnyPermission: (permissions: string[]) => boolean;
  hasAllPermissions: (permissions: string[]) => boolean;
}

const VALUE: PermissionContextType = {
  permissions: ['*'],
  role: 'pm_super_admin',
  isSuperAdmin: true,
  isLoading: false,
  hasPermission: () => true,
  hasAnyPermission: () => true,
  hasAllPermissions: () => true,
};

const PermissionContext = createContext<PermissionContextType | null>(null);

export function PermissionProvider({ children }: { children: ReactNode }) {
  return <PermissionContext.Provider value={VALUE}>{children}</PermissionContext.Provider>;
}

export function usePermissionContext(): PermissionContextType {
  const ctx = useContext(PermissionContext);
  if (!ctx) throw new Error('usePermissionContext must be used within PermissionProvider');
  return ctx;
}
